// extracted by mini-css-extract-plugin
module.exports = {"card":"GroupCard_card__f_ZKz","head":"GroupCard_head__aiZb0","subject":"GroupCard_subject__iR53w","subtitle":"GroupCard_subtitle__uoZy1"};